import { UISwitch } from '@ts/components/UISwitch';

export const init = () => {
    setHTMXListeners();
    setInteractiveElements();
}

const setInteractiveElements = () => {
    setSimpleSwitch();
}

const setSimpleSwitch = () => {
    UISwitch.create(".switch");
}

const setHTMXListeners = () => {
    document.body.addEventListener('htmx:afterSettle', setInteractiveElements);
    document.body.addEventListener('htmx:historyRestore', setInteractiveElements);
}